// extracted by mini-css-extract-plugin
export default {"loading":"Kt2j0oDjJkk1eL0RhXZXNQ==","fa_ani":"imbPAdzCf3wVGpuAEn4AOA==","child_ani":"Mz6wDDVIr+QS2KGu29b2Fw=="};